import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Main from 'layouts/Main';
import React, { useRef } from 'react';
import {
  AcceptanceOfTerms,
  GoverningLaw,
  Hero,
  IntellectualProperty,
  LimitationOfLiability,
  ServicesTerms,
  TableOfContent,
  UserObligations,
} from './components';

const TermsAndConditions = () => {
  const heroRef = useRef();
  const acceptanceRef = useRef();
  const servicesRef = useRef();
  const userObligationsRef = useRef();
  const intellectualPropertyRef = useRef();
  const limitationRef = useRef();
  const governingLawRef = useRef();
  const changesRef = useRef();

  const refs = {
    heroRef,
    acceptanceRef,
    servicesRef,
    userObligationsRef,
    intellectualPropertyRef,
    limitationRef,
    governingLawRef,
    changesRef,
  };

  return (
    <Main>
      <Container>
        <Box ref={heroRef}>
          <Hero />
        </Box>
        <Box>
          <TableOfContent refs={refs} />
        </Box>
        <Box ref={acceptanceRef}>
          <AcceptanceOfTerms />
        </Box>
        <Box ref={servicesRef}>
          <ServicesTerms />
        </Box>
        <Box ref={userObligationsRef}>
          <UserObligations />
        </Box>
        <Box ref={intellectualPropertyRef}>
          <IntellectualProperty />
        </Box>
        <Box ref={limitationRef}>
          <LimitationOfLiability />
        </Box>
        <Box ref={governingLawRef}>
          <GoverningLaw />
        </Box>
      </Container>
    </Main>
  );
};

export default TermsAndConditions;
